import { Card, Col, Row } from "antd";
import React, { useState } from "react";
import AddedPlaylist from "../AddedPlaylist";
import PlaylistFetchcard from "./PlaylistFetchcard";
import PlaylistPreview from "./PlaylistPreview";
import AddFloatingButton from "../AddFloatingButton";
import FlagLocalhost from "../../../Localhost/FlagLocalhost";
import HomeSearch from "../../Search/HomeSearch";
import { PageDataInterface } from "../../../utlis/Interface/homeSearch";
/**
 * Playlist Component
 * ------------------
 * Main playlist  preview screen.
 *
 * Responsibilities:
 * 1. Display user's playlists
 * 2. Handle playlist search (My Playlists)
 * 3. Paginate playlist results
 * 4. Show selected playlist preview
 * 5. Conditionally show floating add button (Evidya)
 */
const Playlist = () => {
	/**
	 * Controls whether playlist preview panel is visible
	 */
	const [isShown, setIsShown] = useState<boolean>(false);

	/**
	 * Pagination state for playlist fetch
	 */
	const [playlistPageData, setPlaylistPageData] = useState<PageDataInterface>(
		{
			page: 1,
			pageSize: 10,
		},
	);

	/**
	 * Search tags for filtering playlists
	 */
	const [searchTags, setSearchTags] = useState<any>([]);

	/**
	 * Environment flag (Evidya / non-Evidya)
	 */
	const flag = FlagLocalhost();

	return (
		<>
			<Row
				gutter={[24, 0]}
				className="flex flex-wrap justify-start items-start"
			>
				<Col xs={24} sm={24} md={11} lg={10} xl={10}>
					<Card className="testplaylist-card">
						<Row gutter={[24, 6]}>
							<Col xl={12} xs={12} md={12}>
								<AddedPlaylist />
							</Col>
						</Row>
						<Row style={{ margin: "10px" }}>
							<Col xl={24} xs={24} md={24}>
								<HomeSearch
									searchMode={4}
									setShowQuestion={() => {}}
									searchTags={searchTags}
									setSearchTags={setSearchTags}
									pageData={playlistPageData}
									playlistPageData={playlistPageData}
								/>
							</Col>
						</Row>
						<Row>
							<Col xl={24} xs={24} md={24} lg={24} sm={24}>
								<PlaylistFetchcard
									isShown={isShown}
									setIsShown={setIsShown}
									playlistPageData={playlistPageData}
									setPlaylistPageData={setPlaylistPageData}
									searchTags={searchTags}
								/>
							</Col>
						</Row>
					</Card>
				</Col>

				<Col
					xs={24}
					sm={24}
					md={13}
					lg={14}
					xl={14}
					style={{ display: "flex", flexDirection: "column" }}
				>
					<PlaylistPreview
						isShown={isShown}
						setIsShown={setIsShown}
					/>
				</Col>
			</Row>
			<Row
				gutter={[24, 0]}
				style={{ position: "fixed", bottom: "4vh", right: "4vw" }}
			>
				{flag?.isFromEvidya === 1 && <AddFloatingButton />}
			</Row>
		</>
	);
};

export default Playlist;
